export enum ImportRequestSource {
  UserUploaded = 'user-uploaded',
  ExternalS3Location = 'external-s3-location'
}

export enum ImportRequestStatus {
  PendingUpload = 'PendingUpload',
  Scanning = 'Scanning',
  PendingVerification = 'PendingVerification',
  Processing = 'Processing',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Failed = 'Failed',
  CopyingExternalCloudLocation = 'CopyingExternalCloudLocation',
  Pending = 'Pending',
  CopyingToAirlockInBucket = 'CopyingToAirlockInBucket',
  Available = 'Available'
}

export enum ImportRequestScanResult {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Clean = 'Clean',
  ThreatDetected = 'ThreatDetected',
  ScanFailed = 'ScanFailed'
}

export enum ImportRequestType {
  ImportRequest = 'import-request'
}

export enum ImportApprovalMethod {
  Auto = 'auto',
  Manual = 'manual'
}

export enum ImportActivityStage {
  Copy = 'copy',
  Scan = 'scan',
  Approval = 'approval',
  Available = 'available'
}

export enum ImportActivityStageState {
  NotStarted = 'notStarted',
  Waiting = 'waiting',
  Active = 'active',
  Complete = 'complete',
  Failed = 'failed',
  Skipped = 'skipped'
}
